import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_MealChart = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_MealChart' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>Lilly Pad - PSR: Sign-in / Meal Chart</h3></p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Name:</span>
                            <input type='text' name='txtName' id='txtName' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Month:</span>
                            <input type='text' name='txtName2' id='txtName2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Year:</span>
                            <input type='text' name='txtName1' id='txtName1' className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Monday</span>
                        </td>
                        <td className='w-250'>
                            <b>Date: </b><input type='date' name='txtDate' id='txtDate' className='add-only w-180 custom-add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>% Consumed</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Time In:</td>
                        <td className='w-250'>
                            <input type='time' name='txtTimeIn' id='txtTimeIn' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtConsumed7' id='txtConsumed7' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Time out:</td>
                        <td className='w-250'>
                            <input type='time' name='txtTimeOut' id='txtTimeOut' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtConsumed6' id='txtConsumed6' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Breakfast</td>
                        <td className='w-250'>
                            <input type='text' name='txtBreakfast' id='txtBreakfast' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtConsumed5' id='txtConsumed5' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Snack</td>
                        <td className='w-250'>
                            <input type='text' name='txtSnack' id='txtSnack' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtConsumed4' id='txtConsumed4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Lunch
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtLunch' id='txtLunch' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtConsumed3' id='txtConsumed3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Snack</td>
                        <td className='w-250'>
                            <input type='text' name='txtSnackSn' id='txtSnackSn' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtConsumed2' id='txtConsumed2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Signature</td>
                        <td className='w-250'>
                            <input type='text' name='txtSignature' id='txtSignature' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtConsumed1' id='txtConsumed1' className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Tuesday</span>
                        </td>
                        <td className='w-250'>
                            <b>Date: </b><input type='date' name='txtDate3' id='txtDate3' className='add-only w-180 custom-add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>% Consumed</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Time In:</td>
                        <td className='w-250'>
                            <input type='time' name='txtTimeIn8' id='txtTimeIn8' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtConsumed8' id='txtConsumed8' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Time out:</td>
                        <td className='w-250'>
                            <input type='time' name='txtTimeOut9' id='txtTimeOut9' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtConsumed9' id='txtConsumed9' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Breakfast</td>
                        <td className='w-250'>
                            <input type='text' name='txtBreakfast10' id='txtBreakfast10' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtConsumed10' id='txtConsumed10' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Snack</td>
                        <td className='w-250'>
                            <input type='text' name='txtSnack11' id='txtSnack11' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtConsumed11' id='txtConsumed11' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Lunch
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtLunch12' id='txtLunch12' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtConsumed12' id='txtConsumed12' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Snack</td>
                        <td className='w-250'>
                            <input type='text' name='txtSnackSn13' id='txtSnackSn13' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtConsumed13' id='txtConsumed13' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Signature</td>
                        <td className='w-250'>
                            <input type='text' name='txtSignature14' id='txtSignature14' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtConsumed15' id='txtConsumed15' className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Wednesday</span>
                        </td>
                        <td className='w-250'>
                            <b>Date: </b><input type='date' name='txtDate2' id='txtDate2' className='add-only w-180 custom-add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>% Consumed</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Time In:</td>
                        <td className='w-250'>
                            <input type='time' name='txtTimeIn16' id='txtTimeIn16' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtConsumed161' id='txtConsumed161' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Time out:</td>
                        <td className='w-250'>
                            <input type='time' name='txtTimeOut17' id='txtTimeOut17' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtConsumed17' id='txtConsumed17' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Breakfast</td>
                        <td className='w-250'>
                            <input type='text' name='txtBreakfast18' id='txtBreakfast18' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtConsumed18' id='txtConsumed18' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Snack</td>
                        <td className='w-250'>
                            <input type='text' name='txtSnack19' id='txtSnack19' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtConsumed19' id='txtConsumed19' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Lunch
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtLunch20' id='txtLunch20' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtConsumed20' id='txtConsumed20' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Snack</td>
                        <td className='w-250'>
                            <input type='text' name='txtSnackSn21' id='txtSnackSn21' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtConsumed21' id='txtConsumed21' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Signature</td>
                        <td className='w-250'>
                            <input type='text' name='txtSignature22' id='txtSignature22' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtConsumed22' id='txtConsumed22' className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Thursday</span>
                        </td>
                        <td className='w-250'>
                            <b>Date: </b><input type='date' name='txtDate4' id='txtDate4' className='add-only w-180 custom-add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>% Consumed</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Time In:</td>
                        <td className='w-250'>
                            <input type='time' name='txtTimeIn23' id='txtTimeIn23' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtConsumed23' id='txtConsumed23' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Time out:</td>
                        <td className='w-250'>
                            <input type='time' name='txtTimeOut24' id='txtTimeOut24' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtConsumed24' id='txtConsumed24' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Breakfast</td>
                        <td className='w-250'>
                            <input type='text' name='txtTimeOut25' id='txtTimeOut25' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtConsumed25' id='txtConsumed25' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Snack</td>
                        <td className='w-250'>
                            <input type='text' name='txtSnack26' id='txtSnack26' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtConsumed26' id='txtConsumed26' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Lunch
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtLunch27' id='txtLunch27' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtConsumed27' id='txtConsumed27' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Snack</td>
                        <td className='w-250'>
                            <input type='text' name='txtSnackSn28' id='txtSnackSn28' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtConsumed28' id='txtConsumed28' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Signature</td>
                        <td className='w-250'>
                            <input type='text' name='txtSignature29' id='txtSignature29' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtConsumed29' id='txtConsumed29' className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Friday</span>
                        </td>
                        <td className='w-250'>
                            <b>Date: </b><input type='date' name='txtDate5' id='txtDate5' className='add-only w-180 custom-add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>% Consumed</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Time In:</td>
                        <td className='w-250'>
                            <input type='time' name='txtTimeIn30' id='txtTimeIn30' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtConsumed30' id='txtConsumed30' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Time out:</td>
                        <td className='w-250'>
                            <input type='time' name='txtTimeOut31' id='txtTimeOut31' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtConsumed31' id='txtConsumed31' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Breakfast</td>
                        <td className='w-250'>
                            <input type='text' name='txtTimeOut32' id='txtTimeOut32' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtConsumed32' id='txtConsumed32' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Snack</td>
                        <td className='w-250'>
                            <input type='text' name='txtSnack33' id='txtSnack33' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtConsumed33' id='txtConsumed33' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Lunch
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtLunch34' id='txtLunch34' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtConsumed34' id='txtConsumed34' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Snack</td>
                        <td className='w-250'>
                            <input type='text' name='txtSnackSn35' id='txtSnackSn35' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtConsumed35' id='txtConsumed35' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Signature</td>
                        <td className='w-250'>
                            <input type='text' name='txtSignature36' id='txtSignature36' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtConsumed36' id='txtConsumed36' className='add-only' />
                        </td>
                    </tr>
                </table>


            </div>
        </form >

    )
}











